import React, { useEffect, useRef, useState } from "react";
import { HiPaperClip, HiDownload } from "react-icons/hi";
// import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import { base_url } from "../../utils/AxiosConfig";
import { base_url_image_post_api } from "../../utils/ImageCreationAPI";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Tooltip from "@mui/material/Tooltip";
const DocumentManagement = () => {
  const fileInputRef = useRef(null);

  const [department, setDepartment] = useState("-");
  const [expiryDate, setExpiryDate] = useState(null);
  const [documentType, setDocumentType] = useState("");
  const [docNoId, setDocNoId] = useState("");
  const [remarks, setRemarks] = useState("");
  const [departmentListFromAPI, setDepartmentListFromAPI] = useState([]);
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [isPopup, setIsPopup] = useState(false);

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleClose = () => {
    setIsPopup(false);
  };

  useEffect(() => {
    getDepartmentList();
  }, []);

  const getDepartmentList = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    const response = await axios.get(
      `${base_url}/api/MASTERLIST/${companyCode}/DEPARTMENT/-`,
    );
    if (response?.data) {
      let newArray = response.data.filter(
        (itemFilly) => itemFilly.Description != "",
      );

      setDepartmentListFromAPI(newArray.map((i) => i.Description));
    } else {
      console.log("error");
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) return;

    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/plain",
    ];

    // if (!allowedTypes.includes(selectedFile.type)) {
    //   setError("Invalid file type");
    //   console.error("Invalid file type");
    //   setFile(null);
    //   return;
    // }

    // if (selectedFile.size > 5 * 1024 * 1024) {
    //   setError("File must be less than 5MB");
    //   console.error("File must be less than 5MB");
    //   setFile(null);
    //   return;
    // }

    setError("");
    setFile(selectedFile);
  };

  const onSaveDocument = () => {
    if (!file) {
      setIsPopup(true);
      return;
    }

    onSaveDocumentAPI();
    // uploadDocumentFileAPI();
  };

  const onSaveDocumentAPI = async () => {
    try {
      const storedUserDataArray =
        JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];

      const companyCode = storedUserDataArray?.[0]?.cmpcode || "";
      // const userName = storedUserDataArray?.[0]?.userid || "admin";
      const deptno = storedUserDataArray?.[0]?.DEPTNO;
      const userName = storedUserDataArray?.[0]?.user;

      const payload = [
        {
          CmpCode: companyCode,
          mode: "ENTRY",
          docid: "0",
          // deptno: deptno,
          // temporary solution 
          // deptno: "MAIN",
          deptno: department,
          docname: documentType,
          doctype: documentType,
          exp_date: expiryDate ? new Date(expiryDate).toISOString() : null,
          remarks: remarks,
          updDate: new Date().toISOString(),
          updBy: userName || "ADMIN",
        },
      ];


      console.log("Payload document Upload:", payload)
      // const payload = [
      //   {
      //      CmpCode: 'CUBIX',
      //     mode: "ENTRY",
      //     docid: "0",
      //     deptno: "MAIN",
      //     docname: "Trade License",
      //     doctype: "LICENSE",
      //     exp_date: "2026-12-31T00:00:00",
      //     remarks: "Valid trade license document",
      //     updDate: "2026-05-16T10:30:00",
      //     updBy: "admin",
      //   },
      // ];

      const response = await axios.post(
        `${base_url}/api/CompanyDocsReg`,
        payload,
      );

      console.log("Save Success", response.data);
      const docNo = response.data.no;

      setDocNoId(docNo);

      if (file) {
        uploadDocumentFileAPI(docNo);
      }
      setSnackbar({
        open: true,
        message: "Document saved successfully",
        severity: "success",
      });

      resetDocumentForm();
      handleClose();
    } catch (err) {
      console.log("Save Error", err);

      setSnackbar({
        open: true,
        message: "Failed to save document",
        severity: "error",
      });
    }
  };

  const uploadDocumentFileAPI = async (docCode) => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }
    try {
      const formData = new FormData();
      formData.append("DOC_CODE", docCode);
      formData.append("DOC_TYPE", "DOCIMAGE");
      formData.append("file", file);
      formData.append("cmpcode", companyCode);
      formData.append("IMGBASE64", "XX");

      let postEmpImagePath = localStorage.getItem("PostEmpImagePath");

      let basePath = postEmpImagePath.replace(/['"]+/g, "").trim();

      if (!basePath.endsWith("\\")) {
        basePath += "\\";
      }

      const fullPath = `${basePath}BONDTIME_DOC_IMG\\`;

      formData.append("IMAGEPATH", fullPath);

      const response = await axios.post(
        // `${base_url_image_post_api}/api/Image/upload`,
        `${base_url_image_post_api}/api/ImageControllerNew/upload`,
        formData,
      );

      console.log("Response From document file upload:", response.data);

      if (response.status === 200) {

        setSnackbar({
          open: true,
          message: "Document file uploaded successfully",
          severity: "success",
        });
        setFile(null);
      }
    } catch (error) {
      console.error("Error uploading data:", error);
      setSnackbar({
        open: true,
        message: "Some error occurred while uploading file",
        severity: "error",
      });
    }
  };

  const resetDocumentForm = () => {
    setDepartment("-");
    setExpiryDate(null);
    setDocumentType("");
    setRemarks("");
    setFile(null);
  };

  const disableDocumentSave =
    department === "-" || !documentType || !expiryDate || !remarks || !file;

  return (
    <div className="w-full">
      <div className="max-w-lg ">
        <div className="flex justify-left items-center mb-6">
          <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
          <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
            <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
              DOCUMENT ATTACHMENT
            </span>
          </h6>
        </div>

        <div className="bg-gray-100 border rounded-lg  p-4 ml-4">
          <div className="mb-2">
            <label className="form-label fs-small text-secondary">
              Department
            </label>

            <select
              value={department || "-"}
              onChange={(e) => setDepartment(e.target.value)}
              className="w-full border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="-">None</option>

              {departmentListFromAPI?.map((b) => (
                <option key={b.DEPTNO} value={b}>
                  {b}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-2">
            <label className="form-label fs-small text-secondary">
              Expiry Date
            </label>
            <input
              type="date"
              className="form-control"
              id="expiryDate"
              name="expiryDate"
              value={expiryDate}
              onChange={(e) => setExpiryDate(e.target.value)}
            />
          </div>





          <div className="mb-2">
            <label className="form-label fs-small text-secondary">
              Document Type
            </label>
            <input
              className="form-control"
              id="documentType"
              name="documentType"
              value={documentType}
              onChange={(e) => setDocumentType(e.target.value)}
            />
          </div>

          <div className="mb-2">
            <label className="form-label fs-small text-secondary">
              Remarks
            </label>
            <input
              className="form-control"
              id="remarks"
              name="remarks"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
            />
          </div>

          {/* File display + button */}
          <div className="mt-4 flex items-center gap-3 border rounded-lg px-3 py-2 bg-gray-50">
            <span className="text-xs text-gray-600 truncate flex-1">
              {file?.name || "No file selected"}
            </span>

            <button
              type="button"
              onClick={() => fileInputRef.current.click()}
              className="flex items-center gap-1 px-3 py-1.5 text-xs bg-green-500 text-white rounded hover:bg-green-600 transition"
            >
              <HiPaperClip className="text-sm" />
              Upload
            </button>
          </div>

          {/* Hidden input */}
          <input
            ref={fileInputRef}
            type="file"
            accept=".pdf,.doc,.docx,.xls,.xlsx,.txt"
            onChange={handleFileChange}
            className="hidden"
          />

          {/* Error */}
          {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
          <div className="flex justify-center items-center">
            <Tooltip
              title="All fields and file must be selected and filled to enable save document"
              disableHoverListener={!disableDocumentSave}
            >
              <span>
                <button
                  // type="button"
                  disabled={disableDocumentSave}
                  onClick={onSaveDocument}
                  className={`mt-4 font-semibold flex items-center justify-center gap-1 px-3 py-1.5 text-sm  text-white rounded
                    ${disableDocumentSave ? "bg-gray-300 hover:bg-gray-400 transition cursor-not-allowed" : "bg-green-500 hover:bg-green-600 transition"} `}
                >
                  {/* <HiDownload className="text-sm" /> */}
                  Save Document
                </button>
              </span>
            </Tooltip>
          </div>
        </div>
        {isPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
            <div className="bg-white w-[400px] rounded-xl shadow-lg overflow-hidden">
              {/* Header */}
              <div className="flex justify-between items-center border-b px-6 py-4 bg-[#2663EB]">
                <h2 className="text-lg font-semibold text-white">
                  Save Document
                </h2>
                <button
                  onClick={handleClose}
                  className="text-white hover:text-red-600 text-2xl font-bold"
                >
                  ×
                </button>
              </div>

              {/* Body */}
              <div className="p-8 text-center">
                <p className="text-gray-700 mb-8 text-lg">
                  Are you sure to save document without attaching file?
                </p>

                <div className="flex items-center justify-center gap-5">
                  <button
                    onClick={handleClose}
                    className=" px-3 py-2.5 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded-lg transition"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={onSaveDocumentAPI}
                    className="px-3 py-2.5 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg transition shadow-sm"
                  >
                    Proceed and Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default DocumentManagement;
